export const route = [
  "/",
  "/login",
  "/signup",
  "/forgotpassword",
  "/my-profile",
  "/otpverification",
  "/resetpassword",
  "/role",
];

export const Without_AuthAccessRoute = [
  "/login",
  "/role",
  "/signup",
  "/forgotpassword",
  "/resetpassword",
];

export const With_AuthAccessRoute = [
  { path: "/my-profile", permission: "", redirect: "" },
  { path: "/setting", permission: "", redirect: "" },
  {
    path: "/my-jobs/submitted-jobs",
    permission: "customer",
    redirect: "/jobpost/new-jobs",
  },
  // {
  //   path: "/jobpost/jobdetails",
  //   permission: "customer",
  //   redirect: "/jobpost/new-jobs",
  // },
  {
    path: "/jobpost/edit",
    permission: "customer",
    redirect: "/jobpost/new-jobs",
  },
  {
    path: "/jobpost/new-jobs",
    permission: "provider",
    redirect: "/my-jobs/submitted-jobs",
  },
  {
    path: "/jobpost/bid-submitted",
    permission: "provider",
    redirect: "/my-jobs/submitted-jobs",
  },
  {
    path: "/subscription-plan",
    permission: "",
    redirect: "",
  },
  // {
  //   path: "/create-post",
  //   permission: "customer",
  //   redirect: "/",
  // },
  {
    path: "/payouts",
    permission: "provider",
    redirect: "/",
  },
  {
    path: "/bank-accounts",
    permission: "provider",
    redirect: "/",
  },
  {
    path: "/promotion-plan",
    permission: "provider",
    redirect: "/",
  },
  {
    path: "/dashboard",
    permission: "provider",
    redirect: "/my-profile",
  },
  {
    path: "/dashboard/profile-reach",
    permission: "provider",
    redirect: "/my-profile",
  },
  {
    path: "/dashboard/bid-insight",
    permission: "provider",
    redirect: "/my-profile",
  },
  {
    path: "/mychat",
    permission: "",
    redirect: "",
  },
];
